import React, { useState, useEffect, useRef } from 'react';
import ensureMapsLoaded from './loadMaps';
import Icon3D from './Icon3D';
import useIsMobile from './useIsMobile';
import { PRIME_PRICE_INR, PRIME_DURATION_DAYS } from './api';

// === DESIGN TOKENS ===
const BLUE = '#2563EB';
const BLUE_DARK = '#1E40AF';
const BLUE_LIGHT = '#3B82F6';
const BLUE_PALE = '#EFF6FF';
const BLUE_GLASS = 'rgba(255,255,255,0.12)';

// === PREMIUM SVG ICONS ===
export const IconSearch = () => (<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" /></svg>);
export const IconHome = () => (<svg viewBox="0 0 48 24" width="48" height="24" fill="none" stroke="url(#gradLogo)" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round"><defs><linearGradient id="gradLogo" x1="0%" y1="0%" x2="100%" y2="0%"><stop offset="0%" stopColor="#3B82F6" /><stop offset="100%" stopColor="#9333EA" /></linearGradient></defs><path d="M 8,18 V 10 L 16,3 L 26,12 C 32,18 44,18 44,12 C 44,6 32,6 26,10 L 18,18 H 8 Z" /><path d="M 11,8 V 3 H 14 V 5" /><path d="M 13,18 V 13 H 17 V 18" /></svg>);
export const IconMapPin = () => (<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" /><circle cx="12" cy="10" r="3" /></svg>);
export const IconFilter = () => (<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" /></svg>);
export const IconCheck = () => (<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12" /></svg>);
export const IconShield = () => (<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" /></svg>);
export const IconHeart = () => (<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" /></svg>);
export const IconMessage = () => (<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" /></svg>);
export const IconUserPlus = () => (<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="8.5" cy="7" r="4" /><line x1="20" y1="8" x2="20" y2="14" /><line x1="23" y1="11" x2="17" y2="11" /></svg>);
export const IconPlayStore = () => (<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="5 3 19 12 5 21 5 3" /></svg>);
export const IconAppStore = () => (<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M12 20.94c1.5 0 2.75 1.06 4 1.06 3 0 6-8 6-12.22A4.91 4.91 0 0 0 17 5c-2.22 0-4 1.44-5 1.44S9.22 5 7 5a4.9 4.9 0 0 0-5 4.78C2 14 5 22 8 22c1.25 0 2.5-1.06 4-1.06Z" /><path d="M10 2c1 .5 2 2 2 5" /></svg>);
export const IconStar = () => (<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" stroke="none"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" /></svg>);
export const IconArrow = () => (<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="5" y1="12" x2="19" y2="12" /><polyline points="12 5 19 12 12 19" /></svg>);
export const IconBolt = () => (<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" /></svg>);
export const IconPhone = () => (<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><rect x="5" y="2" width="14" height="20" rx="2" ry="2" /><line x1="12" y1="18" x2="12.01" y2="18" /></svg>);

// ============================================================
// === 1. HERO SECTION ===
// ============================================================
/**
 * Location search with Google Places autocomplete, on a light background.
 *
 * <p>Lifted out of HeroSection so the redesigned home page can reuse the exact
 * same behaviour — debounce, India restriction, place-details lookup for real
 * coordinates — instead of carrying a second, subtly different copy of it. The
 * hero's own version stays where it is; this one is styled for white.
 */
export const LocationSearchBox = ({ onSelect, placeholder = 'Search area, locality or city' }) => {
    const [query, setQuery] = useState('');
    const [suggestions, setSuggestions] = useState([]);
    const [open, setOpen] = useState(false);
    const [busy, setBusy] = useState(false);
    const boxRef = useRef(null);
    const autocompleteService = useRef(null);
    const placesService = useRef(null);
    const timer = useRef(null);

    useEffect(() => {
        const onDocClick = (e) => {
            if (boxRef.current && !boxRef.current.contains(e.target)) setOpen(false);
        };
        document.addEventListener('mousedown', onDocClick);
        return () => document.removeEventListener('mousedown', onDocClick);
    }, []);

    useEffect(() => {
        const init = () => {
            if (window.google?.maps?.places) {
                autocompleteService.current = new window.google.maps.places.AutocompleteService();
                placesService.current = new window.google.maps.places.PlacesService(document.createElement('div'));
            }
        };
        if (window.google) init();
        else {
            const iv = setInterval(() => { if (window.google) { init(); clearInterval(iv); } }, 100);
            return () => clearInterval(iv);
        }
    }, []);

    const onInput = (e) => {
        const v = e.target.value;
        setQuery(v);
        if (timer.current) clearTimeout(timer.current);
        if (!v.trim()) { setSuggestions([]); setOpen(false); return; }
        setOpen(true);
        setBusy(true);
        timer.current = setTimeout(() => {
            if (!autocompleteService.current) { setBusy(false); return; }
            autocompleteService.current.getPlacePredictions(
                { input: v, componentRestrictions: { country: 'in' } },
                (preds, status) => {
                    setBusy(false);
                    setSuggestions(status === window.google.maps.places.PlacesServiceStatus.OK && preds ? preds : []);
                }
            );
        }, 500);
    };

    const pick = (sug) => {
        const mainText = sug.structured_formatting.main_text;
        setQuery(mainText);
        setOpen(false);
        if (!placesService.current) { onSelect({ name: mainText }); return; }
        placesService.current.getDetails({ placeId: sug.place_id, fields: ['geometry'] }, (place, status) => {
            if (status === window.google.maps.places.PlacesServiceStatus.OK && place?.geometry?.location) {
                onSelect({ name: mainText, lat: place.geometry.location.lat(), lng: place.geometry.location.lng() });
            } else {
                onSelect({ name: mainText });
            }
        });
    };

    const submit = () => { if (query.trim()) onSelect({ name: query.trim() }); };

    return (
        <div ref={boxRef} style={{ position: 'relative' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', paddingLeft: '16px' }}>
                <span style={{ color: '#94A3B8', display: 'flex', flexShrink: 0 }}><IconSearch /></span>
                <input
                    type="text"
                    value={query}
                    onChange={onInput}
                    onKeyDown={(e) => { if (e.key === 'Enter') submit(); }}
                    onFocus={() => {
                        // The SDK is 1.3 MB. A visitor who never touches the
                        // search box should never pay for it.
                        ensureMapsLoaded().catch(() => {});
                        if (query) setOpen(true);
                    }}
                    placeholder={placeholder}
                    aria-label="Search for flats, rooms and PG by location"
                    style={{ flex: 1, minWidth: 0, border: 'none', outline: 'none', background: 'transparent', fontSize: '16px', fontWeight: 500, color: '#0F172A', padding: '15px 0', fontFamily: 'inherit' }}
                />
                <button
                    onClick={submit}
                    aria-label="Search"
                    style={{ flexShrink: 0, padding: '13px 28px', borderRadius: '14px', background: '#4285F4', color: '#FFFFFF', border: 'none', fontSize: '15px', fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit' }}
                >
                    Search
                </button>
            </div>

            {open && (query.trim().length > 0) && (
                <div style={{ position: 'absolute', top: 'calc(100% + 10px)', left: 0, right: 0, background: '#FFFFFF', borderRadius: '18px', boxShadow: '0 16px 40px rgba(11,18,32,0.14)', overflow: 'hidden', zIndex: 40 }}>
                    {busy && <div style={{ padding: '16px 20px', fontSize: '14px', color: '#9AA3AF' }}>Searching…</div>}
                    {!busy && suggestions.length === 0 && <div style={{ padding: '16px 20px', fontSize: '14px', color: '#9AA3AF' }}>No places found</div>}
                    {suggestions.map((s) => (
                        <button
                            key={s.place_id}
                            onClick={() => pick(s)}
                            style={{ display: 'flex', alignItems: 'center', gap: '12px', width: '100%', padding: '14px 20px', background: 'none', border: 'none', borderBottom: '1px solid #EEF0F3', cursor: 'pointer', fontFamily: 'inherit', textAlign: 'left' }}
                            onMouseOver={(e) => { e.currentTarget.style.background = '#F7F8FA'; }}
                            onMouseOut={(e) => { e.currentTarget.style.background = 'none'; }}
                        >
                            <span style={{ color: '#4285F4', display: 'flex', flexShrink: 0 }}><IconMapPin /></span>
                            <span style={{ minWidth: 0 }}>
                                <span style={{ display: 'block', fontSize: '14.5px', fontWeight: 700, color: '#0F172A' }}>{s.structured_formatting.main_text}</span>
                                <span style={{ display: 'block', fontSize: '12.5px', color: '#6B7280', marginTop: '1px' }}>{s.structured_formatting.secondary_text}</span>
                            </span>
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
};

export const HeroSection = ({ onSearchClick, onRentInsights }) => {
    const [searchQuery, setSearchQuery] = useState('');
    const [suggestions, setSuggestions] = useState([]);
    const [showSuggestions, setShowSuggestions] = useState(false);
    const [isSearchingLocation, setIsSearchingLocation] = useState(false);
    const searchRef = useRef(null);
    const autocompleteService = useRef(null);
    const placesService = useRef(null);
    const isMobile = useIsMobile(480);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (searchRef.current && !searchRef.current.contains(event.target)) {
                setShowSuggestions(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    useEffect(() => {
        ensureMapsLoaded().catch(() => {});
        const initGoogleMaps = () => {
            if (window.google && window.google.maps && window.google.maps.places) {
                autocompleteService.current = new window.google.maps.places.AutocompleteService();
                const dummyDiv = document.createElement('div');
                placesService.current = new window.google.maps.places.PlacesService(dummyDiv);
            }
        };
        if (window.google) initGoogleMaps();
        else {
            const interval = setInterval(() => {
                if (window.google) { initGoogleMaps(); clearInterval(interval); }
            }, 100);
            return () => clearInterval(interval);
        }
    }, []);

    const searchTimeout = useRef(null);
    const handleSearchInput = (e) => {
        const value = e.target.value;
        setSearchQuery(value);
        if (searchTimeout.current) clearTimeout(searchTimeout.current);
        if (!value.trim()) { setSuggestions([]); setShowSuggestions(false); return; }
        setShowSuggestions(true);
        setIsSearchingLocation(true);
        searchTimeout.current = setTimeout(() => {
            if (!autocompleteService.current) { setIsSearchingLocation(false); return; }
            autocompleteService.current.getPlacePredictions(
                { input: value, componentRestrictions: { country: 'in' } },
                (predictions, status) => {
                    setIsSearchingLocation(false);
                    if (status === window.google.maps.places.PlacesServiceStatus.OK && predictions) setSuggestions(predictions);
                    else setSuggestions([]);
                }
            );
        }, 500);
    };

    const handleSelectSuggestion = (suggestion) => {
        const placeId = suggestion.place_id;
        const mainText = suggestion.structured_formatting.main_text;
        setSearchQuery(mainText);
        setShowSuggestions(false);
        if (!placesService.current) return;
        placesService.current.getDetails({ placeId, fields: ['geometry'] }, (place, status) => {
            if (status === window.google.maps.places.PlacesServiceStatus.OK && place?.geometry?.location) {
                onSearchClick({ name: mainText, lat: place.geometry.location.lat(), lng: place.geometry.location.lng() });
            }
        });
    };

    const cities = [
        { name: 'Bangalore', lat: 12.9716, lng: 77.5946 },
        { name: 'Delhi', lat: 28.6138, lng: 77.2090 },
        { name: 'Hyderabad', lat: 17.3850, lng: 78.4867 },
        { name: 'Pune', lat: 18.5204, lng: 73.8567 },
        { name: 'Mumbai', lat: 19.0760, lng: 72.8777 },
        { name: 'Chennai', lat: 13.0827, lng: 80.2707 },
    ];

    return (
        <header style={{ width: '100%', position: 'relative', overflow: 'hidden' }}>
            {/* === BLUE GRADIENT BANNER === */}
            <div style={{
                background: `linear-gradient(155deg, ${BLUE_DARK} 0%, ${BLUE} 55%, ${BLUE_LIGHT} 100%)`,
                padding: '110px 20px 80px',
                position: 'relative',
            }}>
                {/* Decorative orbs */}
                <div style={{ position: 'absolute', top: '-100px', right: '-100px', width: '500px', height: '500px', background: 'rgba(255,255,255,0.05)', borderRadius: '50%', pointerEvents: 'none' }} />
                <div style={{ position: 'absolute', bottom: '-60px', left: '-80px', width: '320px', height: '320px', background: 'rgba(255,255,255,0.04)', borderRadius: '50%', pointerEvents: 'none' }} />
                <div style={{ position: 'absolute', top: '40%', left: '8%', width: '180px', height: '180px', background: 'rgba(255,255,255,0.03)', borderRadius: '50%', pointerEvents: 'none' }} />

                <div style={{ maxWidth: '860px', margin: '0 auto', position: 'relative', zIndex: 1, textAlign: 'center' }}>
                    {/* Trust pill */}
                    <div style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', background: BLUE_GLASS, backdropFilter: 'blur(12px)', padding: '8px 20px', borderRadius: '30px', marginBottom: '24px', border: '1px solid rgba(255,255,255,0.22)' }}>
                        <span style={{ width: '22px', height: '22px', borderRadius: '50%', background: 'rgba(255,255,255,0.92)', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                            <Icon3D name="verified" size={15} />
                        </span>
                        <span style={{ color: 'white', fontSize: '13px', fontWeight: '700', letterSpacing: '0.5px' }}>Phone-Verified Users · Zero Brokerage</span>
                    </div>

                    {/* H1 — keyword rich SEO */}
                    <h1 style={{ fontSize: 'clamp(32px, 6vw, 58px)', fontWeight: '800', color: 'white', lineHeight: '1.1', marginBottom: '14px', letterSpacing: '-1.5px' }}>
                        Find Flatmates, Rooms &amp; PGs<br />
                        <span style={{ color: '#93C5FD' }}>in Delhi, Mumbai &amp; Bangalore</span>
                    </h1>
                    <p style={{ fontSize: 'clamp(14px, 2vw, 18px)', color: '#BFDBFE', fontWeight: '400', lineHeight: '1.7', maxWidth: '560px', margin: '0 auto 24px' }}>
                        Every account is phone-verified. Talk to flat owners and tenants directly — no middlemen, no brokerage, no commission. Shared flats, private rooms, PG and roommates across 10 Indian cities.
                    </p>

                    {/* Feature highlights strip */}
                    <div style={{ display: 'flex', gap: '10px', justifyContent: 'center', flexWrap: 'wrap', marginBottom: '28px' }}>
                        {[
                            { icon: 'insights', label: 'Rent Insights', action: () => onRentInsights && onRentInsights() },
                            { icon: 'verified', label: 'Verified Users' },
                            { icon: 'prime', label: 'Zero Brokerage' },
                            { icon: 'chat', label: 'Direct Chat' },
                        ].map((f, i) => (
                            <div key={i}
                                onClick={f.action || undefined}
                                style={{
                                    display: 'inline-flex', alignItems: 'center', gap: '6px',
                                    background: f.action ? 'rgba(16,185,129,0.2)' : 'rgba(255,255,255,0.1)',
                                    backdropFilter: 'blur(10px)',
                                    padding: '8px 16px', borderRadius: '24px',
                                    border: f.action ? '1px solid rgba(16,185,129,0.4)' : '1px solid rgba(255,255,255,0.18)',
                                    cursor: f.action ? 'pointer' : 'default',
                                    transition: 'all 0.2s',
                                }}
                                onMouseOver={e => { if (f.action) { e.currentTarget.style.background = 'rgba(16,185,129,0.35)'; e.currentTarget.style.transform = 'translateY(-2px)'; } else { e.currentTarget.style.background = 'rgba(255,255,255,0.18)'; } }}
                                onMouseOut={e => { e.currentTarget.style.background = f.action ? 'rgba(16,185,129,0.2)' : 'rgba(255,255,255,0.1)'; e.currentTarget.style.transform = 'translateY(0)'; }}>
                                <span style={{ width: '26px', height: '26px', borderRadius: '50%', background: 'rgba(255,255,255,0.92)', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                    <Icon3D name={f.icon} size={17} />
                                </span>
                                <span style={{ color: 'white', fontSize: '13px', fontWeight: '700', letterSpacing: '0.3px' }}>{f.label}</span>
                                {f.action && <span style={{ fontSize: '10px', color: '#6EE7B7', fontWeight: '800' }}>NEW</span>}
                            </div>
                        ))}
                    </div>

                    {/* ======= SEARCH BAR — INSIDE HERO ======= */}
                    <div style={{ maxWidth: '700px', margin: '0 auto 36px', position: 'relative' }} ref={searchRef}>
                        {/* Glassmorphism outer wrapper */}
                        <div style={{
                            background: 'rgba(255,255,255,0.13)',
                            backdropFilter: 'blur(24px)',
                            borderRadius: '22px',
                            padding: '7px',
                            border: '1px solid rgba(255,255,255,0.28)',
                            boxShadow: '0 24px 64px rgba(0,0,0,0.22)',
                        }}>
                            <div style={{
                                display: 'flex', alignItems: 'center',
                                background: 'white', borderRadius: '16px',
                                padding: isMobile ? '4px 4px 4px 12px' : '4px 4px 4px 20px',
                                overflow: 'hidden',
                            }}>
                                <div style={{ color: BLUE, display: 'flex', marginRight: isMobile ? '8px' : '12px', flexShrink: 0 }}><IconSearch /></div>
                                <input
                                    type="text"
                                    value={searchQuery}
                                    onChange={handleSearchInput}
                                    onFocus={() => { if (searchQuery) setShowSuggestions(true); }}
                                    placeholder={isMobile ? 'Search area or city...' : 'Search by area, locality, or city...'}
                                    aria-label="Search for flats, rooms and PGs by location"
                                    style={{
                                        flex: 1, border: 'none', outline: 'none',
                                        background: 'transparent', fontSize: isMobile ? '14px' : '16px',
                                        fontWeight: '500', color: '#1F2937', padding: isMobile ? '12px 0' : '14px 0',
                                        minWidth: 0,
                                    }}
                                />
                                <button
                                    onClick={() => { if (searchQuery) onSearchClick({ name: searchQuery }); }}
                                    aria-label="Search for flats"
                                    style={{
                                        background: `linear-gradient(135deg, ${BLUE_DARK}, ${BLUE_LIGHT})`,
                                        color: 'white', border: 'none',
                                        padding: isMobile ? '12px 16px' : '14px 32px', borderRadius: '12px',
                                        fontWeight: '800', cursor: 'pointer', fontSize: isMobile ? '13px' : '15px',
                                        flexShrink: 0, boxShadow: '0 6px 20px rgba(37,99,235,0.45)',
                                        transition: 'opacity 0.15s, transform 0.15s',
                                        whiteSpace: 'nowrap'
                                    }}
                                    onMouseOver={e => { e.currentTarget.style.opacity = '0.9'; e.currentTarget.style.transform = 'scale(1.02)'; }}
                                    onMouseOut={e => { e.currentTarget.style.opacity = '1'; e.currentTarget.style.transform = 'scale(1)'; }}
                                >
                                    Search
                                </button>
                            </div>
                        </div>

                        {/* Suggestions dropdown */}
                        {showSuggestions && (
                            <div style={{
                                position: 'absolute', top: 'calc(100% + 10px)', left: 0, right: 0,
                                background: 'white', borderRadius: '20px',
                                boxShadow: '0 24px 64px rgba(0,0,0,0.20)',
                                overflow: 'hidden', zIndex: 200,
                                border: '1px solid #E5E7EB', padding: '8px', textAlign: 'left'
                            }}>
                                {isSearchingLocation ? (
                                    <div style={{ padding: '18px', color: '#6B7280', textAlign: 'center', fontSize: '14px' }}>Searching places...</div>
                                ) : suggestions.length > 0 ? (
                                    suggestions.map((sugg, idx) => (
                                        <div key={idx} onClick={() => handleSelectSuggestion(sugg)}
                                            style={{ padding: '14px 16px', display: 'flex', alignItems: 'center', cursor: 'pointer', borderRadius: '14px', transition: 'background 0.15s' }}
                                            onMouseOver={e => e.currentTarget.style.background = BLUE_PALE}
                                            onMouseOut={e => e.currentTarget.style.background = 'transparent'}>
                                            <div style={{ width: '38px', height: '38px', background: BLUE_PALE, color: BLUE, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}><IconMapPin /></div>
                                            <div style={{ marginLeft: '14px' }}>
                                                <div style={{ fontWeight: '700', color: '#1F2937', fontSize: '14px' }}>{sugg.structured_formatting?.main_text || sugg.description}</div>
                                                <div style={{ fontSize: '12px', color: '#6B7280', marginTop: '2px' }}>{sugg.structured_formatting?.secondary_text || ''}</div>
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <div style={{ padding: '18px', color: '#6B7280', textAlign: 'center', fontSize: '14px' }}>No places found.</div>
                                )}
                            </div>
                        )}

                        {/* City pills — below the search box, inside hero */}
                        <div style={{ marginTop: '16px', display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap', justifyContent: 'center' }}>
                            <span style={{ fontSize: '12px', fontWeight: '700', color: 'rgba(255,255,255,0.55)', textTransform: 'uppercase', letterSpacing: '1px' }}>Try:</span>
                            {cities.map(city => (
                                <button key={city.name} onClick={() => onSearchClick(city)}
                                    style={{
                                        color: 'white', fontWeight: '600', cursor: 'pointer',
                                        background: 'rgba(255,255,255,0.14)',
                                        backdropFilter: 'blur(8px)',
                                        padding: '5px 16px', borderRadius: '20px', fontSize: '13px',
                                        border: '1px solid rgba(255,255,255,0.22)',
                                        transition: 'all 0.18s'
                                    }}
                                    onMouseOver={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.26)'; e.currentTarget.style.borderColor = 'rgba(255,255,255,0.5)'; }}
                                    onMouseOut={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.14)'; e.currentTarget.style.borderColor = 'rgba(255,255,255,0.22)'; }}>
                                    {city.name}
                                </button>
                            ))}
                        </div>
                    </div>
                    {/* ======= END SEARCH BAR ======= */}

                    {/* Stats row — glass card at bottom of hero */}
                    <div style={{
                        display: 'flex', gap: '0', justifyContent: 'center', flexWrap: 'wrap',
                        background: 'rgba(255,255,255,0.10)', backdropFilter: 'blur(12px)',
                        borderRadius: '20px', border: '1px solid rgba(255,255,255,0.16)',
                        padding: '22px 32px', maxWidth: '620px', margin: '0 auto'
                    }}>
                        {[['10', 'Cities'], ['₹0', 'Brokerage'], ['₹0', 'Commission'], ['OTP', 'Verified']].map(([val, label], i, arr) => (
                            <div key={label} style={{
                                textAlign: 'center', flex: '1', minWidth: '100px',
                                borderRight: i < arr.length - 1 ? '1px solid rgba(255,255,255,0.15)' : 'none',
                                padding: '0 20px'
                            }}>
                                <div style={{ fontSize: '22px', fontWeight: '800', color: 'white', letterSpacing: '-1px' }}>{val}</div>
                                <div style={{ fontSize: '11px', color: '#BFDBFE', fontWeight: '600', marginTop: '4px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>{label}</div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* Smooth bottom transition */}
            <div style={{ height: '24px', background: '#F8FAFF' }} />
        </header>
    );
};

// ============================================================
// === 2. HOW IT WORKS ===
// ============================================================
export const HowItWorksSection = () => {
    const steps = [
        {
            icon: <IconSearch />,
            num: '01',
            title: 'Search & Filter',
            desc: 'Tell us what you need — city, budget, veg/non-veg preference, sleep schedule. We\'ll surface the perfect matches.',
            color: BLUE,
            bg: BLUE_PALE,
        },
        {
            icon: <IconBolt />,
            num: '02',
            title: 'Smart Matches',
            desc: 'Our engine ranks listings and flatmate profiles by compatibility — not just price. Find people on your wavelength.',
            color: '#7C3AED',
            bg: '#F5F3FF',
        },
        {
            icon: <IconMessage />,
            num: '03',
            title: 'Chat Directly',
            desc: 'Message owners and flatmates directly inside the app. No brokerage middlemen, no WhatsApp strangers.',
            color: '#059669',
            bg: '#ECFDF5',
        },
    ];

    return (
        <section id="how-it-works" style={{ padding: '100px 20px', background: '#F8FAFF' }}>
            <div style={{ maxWidth: '1100px', margin: '0 auto' }}>
                {/* Section header */}
                <div style={{ textAlign: 'center', marginBottom: '64px' }}>
                    <div style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', background: BLUE_PALE, color: BLUE, padding: '8px 20px', borderRadius: '30px', fontSize: '13px', fontWeight: '800', marginBottom: '16px', letterSpacing: '0.5px', textTransform: 'uppercase' }}>
                        Simple Process
                    </div>
                    <h2 style={{ fontSize: 'clamp(28px, 4vw, 44px)', fontWeight: '800', color: '#111827', letterSpacing: '-1px', marginBottom: '16px' }}>
                        Find your perfect flatmate in 3 steps
                    </h2>
                    <p style={{ fontSize: '18px', color: '#6B7280', maxWidth: '520px', margin: '0 auto', lineHeight: '1.7' }}>
                        Go from confused to settled in days — not months. Zero broker fees, guaranteed.
                    </p>
                </div>

                {/* Step cards */}
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '24px' }}>
                    {steps.map((step, i) => (
                        <div key={i} style={{ background: 'white', borderRadius: '28px', padding: '36px 28px', boxShadow: '0 4px 24px rgba(0,0,0,0.05)', position: 'relative', overflow: 'hidden', border: '1px solid #F3F4F6', transition: 'transform 0.2s, box-shadow 0.2s' }}
                            onMouseOver={e => { e.currentTarget.style.transform = 'translateY(-4px)'; e.currentTarget.style.boxShadow = '0 16px 40px rgba(0,0,0,0.1)'; }}
                            onMouseOut={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 4px 24px rgba(0,0,0,0.05)'; }}>
                            {/* Big step number in background */}
                            <div style={{ position: 'absolute', top: '16px', right: '20px', fontSize: '64px', fontWeight: '900', color: step.bg, lineHeight: 1, userSelect: 'none' }}>{step.num}</div>
                            {/* Icon */}
                            <div style={{ width: '56px', height: '56px', background: step.bg, color: step.color, borderRadius: '18px', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '24px' }}>
                                {step.icon}
                            </div>
                            <h3 style={{ fontSize: '20px', fontWeight: '800', color: '#111827', marginBottom: '10px' }}>{step.title}</h3>
                            <p style={{ color: '#6B7280', fontSize: '15px', lineHeight: '1.7', margin: 0 }}>{step.desc}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

// ============================================================
// === 3. APP FEATURES ===
// ============================================================
export const AppFeaturesSection = () => {
    const features = [
        { icon: <IconShield />, color: BLUE, bg: BLUE_PALE, title: 'Phone-Verified Users', desc: 'Every account is verified by phone OTP before it can post a listing or send a message, so you are always dealing with a reachable person.' },
        { icon: <IconFilter />, color: '#7C3AED', bg: '#F5F3FF', title: 'Deep Lifestyle Filtering', desc: 'Filter by diet, sleep schedule, pets, gender preference, and more. Only see truly compatible people.' },
        { icon: <IconMessage />, color: '#059669', bg: '#ECFDF5', title: 'Ghost-free Direct Chat', desc: 'Talk directly with owners and flatmates inside a secure in-app chat. No ghosting, no third parties.' },
        { icon: <IconBolt />, color: '#D97706', bg: '#FFFBEB', title: 'Instant Matching', desc: 'Our algorithm matches you with the most compatible listings and roommates automatically — in seconds.' },
        { icon: <IconPhone />, color: '#DB2777', bg: '#FDF2F8', title: 'Mobile App Available', desc: 'Download on Android or iOS. Manage your search, chat, and listings anywhere you go.' },
        { icon: <IconHeart />, color: '#DC2626', bg: '#FEF2F2', title: 'Save & Compare', desc: 'Shortlist your favourite rooms and compare them side by side before making any commitments.' },
    ];

    return (
        <section id="features" style={{ padding: '100px 20px', background: 'white' }}>
            <div style={{ maxWidth: '1100px', margin: '0 auto' }}>
                <div style={{ textAlign: 'center', marginBottom: '64px' }}>
                    <div style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', background: BLUE_PALE, color: BLUE, padding: '8px 20px', borderRadius: '30px', fontSize: '13px', fontWeight: '800', marginBottom: '16px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                        Why FlatLoop
                    </div>
                    <h2 style={{ fontSize: 'clamp(28px, 4vw, 44px)', fontWeight: '800', color: '#111827', letterSpacing: '-1px', marginBottom: '16px' }}>
                        Everything you need.<br />Nothing you don't.
                    </h2>
                    <p style={{ fontSize: '18px', color: '#6B7280', maxWidth: '520px', margin: '0 auto', lineHeight: '1.7' }}>
                        Built for India's rental market — where trust, speed, and no-brokerage actually matter.
                    </p>
                </div>

                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '20px' }}>
                    {features.map((f, i) => (
                        <div key={i} style={{ background: '#FAFAFA', borderRadius: '24px', padding: '28px', display: 'flex', gap: '18px', alignItems: 'flex-start', border: '1px solid #F3F4F6', transition: 'all 0.2s' }}
                            onMouseOver={e => { e.currentTarget.style.background = 'white'; e.currentTarget.style.boxShadow = '0 8px 32px rgba(0,0,0,0.08)'; e.currentTarget.style.borderColor = '#E5E7EB'; }}
                            onMouseOut={e => { e.currentTarget.style.background = '#FAFAFA'; e.currentTarget.style.boxShadow = 'none'; e.currentTarget.style.borderColor = '#F3F4F6'; }}>
                            <div style={{ width: '48px', height: '48px', background: f.bg, color: f.color, borderRadius: '14px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                {f.icon}
                            </div>
                            <div>
                                <h4 style={{ fontSize: '16px', fontWeight: '800', color: '#111827', marginBottom: '6px' }}>{f.title}</h4>
                                <p style={{ color: '#6B7280', fontSize: '14px', lineHeight: '1.6', margin: 0 }}>{f.desc}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

// ============================================================
// === 4. CITIES WE SERVE ===
// ============================================================
export const CitiesSection = ({ onSearchClick }) => {
    const cities = [
        { name: 'Bangalore', img: '/cities/bangalore.png', listings: '5,000+', lat: 12.9716, lng: 77.5946 },
        { name: 'Delhi', img: '/cities/delhi.png', listings: '5,000+', lat: 28.6138, lng: 77.2090 },
        { name: 'Mumbai', img: '/cities/mumbai.png', listings: '5,000+', lat: 19.0760, lng: 72.8777 },
        { name: 'Hyderabad', img: '/cities/hyderabad.png', listings: '5,000+', lat: 17.3850, lng: 78.4867 },
        { name: 'Pune', img: '/cities/pune.png', listings: '5,000+', lat: 18.5204, lng: 73.8567 },
        { name: 'Chennai', img: '/cities/chennai.png', listings: '3,000+', lat: 13.0827, lng: 80.2707 },
        { name: 'Gurgaon', img: '/cities/gurgaon.png', listings: '3,000+', lat: 28.4595, lng: 77.0266 },
        { name: 'Noida', img: '/cities/noida.png', listings: '3,000+', lat: 28.5355, lng: 77.3910 },
        { name: 'Kolkata', img: '/cities/kolkata.png', listings: '2,000+', lat: 22.5726, lng: 88.3639 },
        { name: 'Ahmedabad', img: '/cities/ahmedabad.png', listings: '2,000+', lat: 23.0225, lng: 72.5714 },
    ];

    const isMobile = useIsMobile(768);

    return (
        <section id="cities" style={{ padding: '80px 20px 100px', background: '#F8FAFF' }}>
            <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
                <div style={{ textAlign: 'center', marginBottom: '48px' }}>
                    <div style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', background: BLUE_PALE, color: BLUE, padding: '8px 20px', borderRadius: '30px', fontSize: '13px', fontWeight: '800', marginBottom: '16px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                        Explore Cities
                    </div>
                    <h2 style={{ fontSize: 'clamp(28px, 4vw, 44px)', fontWeight: '800', color: '#111827', letterSpacing: '-1px', marginBottom: '16px' }}>
                        Properties across India's top cities
                    </h2>
                    <p style={{ fontSize: '18px', color: '#6B7280', maxWidth: '520px', margin: '0 auto', lineHeight: '1.7' }}>
                        From metros to tech hubs — find verified flats &amp; roommates wherever your career takes you.
                    </p>
                </div>

                {/* Scrollable on mobile, grid on desktop */}
                <div style={isMobile ? {
                    display: 'flex', gap: '16px', overflowX: 'auto', paddingBottom: '16px',
                    scrollSnapType: 'x mandatory', WebkitOverflowScrolling: 'touch',
                    msOverflowStyle: 'none', scrollbarWidth: 'none',
                } : {
                    display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: '20px',
                }}>
                    {cities.map((city, i) => (
                        <div key={i}
                            onClick={() => onSearchClick && onSearchClick(city)}
                            style={{
                                position: 'relative', borderRadius: '20px', overflow: 'hidden',
                                cursor: onSearchClick ? 'pointer' : 'default',
                                transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                                scrollSnapAlign: 'start',
                                minWidth: isMobile ? '160px' : 'auto',
                                aspectRatio: '3 / 4',
                                boxShadow: '0 4px 16px rgba(0,0,0,0.08)',
                            }}
                            onMouseOver={e => { e.currentTarget.style.transform = 'translateY(-6px)'; e.currentTarget.style.boxShadow = '0 16px 40px rgba(0,0,0,0.15)'; }}
                            onMouseOut={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 4px 16px rgba(0,0,0,0.08)'; }}>

                            {/* City image */}
                            <img
                                src={city.img}
                                alt={`${city.name} - Find flats and rooms`}
                                loading="lazy"
                                style={{
                                    width: '100%', height: '100%',
                                    objectFit: 'cover', display: 'block',
                                }}
                            />

                            {/* Gradient overlay */}
                            <div style={{
                                position: 'absolute', inset: 0,
                                background: 'linear-gradient(to top, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.1) 50%, rgba(0,0,0,0.0) 100%)',
                            }} />

                            {/* City name + listings */}
                            <div style={{
                                position: 'absolute', bottom: 0, left: 0, right: 0,
                                padding: '20px 16px',
                            }}>
                                <div style={{
                                    fontSize: '18px', fontWeight: '800', color: 'white',
                                    marginBottom: '4px', textShadow: '0 2px 8px rgba(0,0,0,0.3)',
                                }}>
                                    {city.name}
                                </div>
                                <div style={{
                                    fontSize: '13px', fontWeight: '600', color: 'rgba(255,255,255,0.85)',
                                }}>
                                    {city.listings} listings
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {/* SEO: Popular Searches — keyword-rich crawlable text */}
                <div style={{ marginTop: '48px', textAlign: 'center' }}>
                    <h3 style={{ fontSize: '18px', fontWeight: '800', color: '#374151', marginBottom: '20px' }}>Popular Searches</h3>
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', justifyContent: 'center', maxWidth: '900px', margin: '0 auto' }}>
                        {[
                            'Flatmate in Delhi', 'Roommate in Bangalore', 'Shared Flat in Mumbai',
                            'PG in Hyderabad', 'Room for Rent in Pune', 'Flatmate in Gurgaon',
                            'PG in Noida', 'Flat Without Broker in Delhi', 'Roommate in Chennai',
                            'Shared Accommodation Kolkata', 'Female Flatmate Delhi', 'Male Roommate Bangalore',
                            'Flat for Rent Mumbai', '1BHK Rent Delhi', '2BHK Flat Bangalore',
                            'Paying Guest Hyderabad', 'Boys PG Pune', 'Girls PG Gurgaon',
                            'Bachelor Room Noida', 'Zero Brokerage Flat Mumbai',
                            'Affordable PG Bangalore', 'Verified Flatmate Delhi',
                            'Flat Sharing App India', 'No Broker Flat Pune',
                            'Flatmate Finder App', 'Roommate Finder India',
                            'Flat Without Broker Ahmedabad', 'Room for Rent in Kolkata',
                        ].map((term, i) => (
                            <span key={i}
                                onClick={() => onSearchClick && onSearchClick({ name: term.split(' in ').pop() || term.split(' ').pop() })}
                                style={{
                                    background: 'white', color: '#4B5563', padding: '8px 16px',
                                    borderRadius: '20px', fontSize: '13px', fontWeight: '600',
                                    border: '1px solid #E5E7EB', cursor: 'pointer',
                                    transition: 'all 0.2s',
                                }}
                                onMouseOver={e => { e.currentTarget.style.background = '#2563EB'; e.currentTarget.style.color = 'white'; e.currentTarget.style.borderColor = '#2563EB'; }}
                                onMouseOut={e => { e.currentTarget.style.background = 'white'; e.currentTarget.style.color = '#4B5563'; e.currentTarget.style.borderColor = '#E5E7EB'; }}
                            >{term}</span>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

// ============================================================
// === 5. TESTIMONIALS ===
// ============================================================
export const TestimonialsSection = () => {
    const reviews = [
        { text: '"Shifting to Bangalore without any connections was terrifying. FlatLoop matched me with a verified IT professional — moved in within a week!"', name: 'Priya M.', role: 'Software Engineer, Bengaluru', rating: 5, initials: 'PM', color: BLUE },
        { text: '"As a landlord who was previously scammed by brokers, this is a game-changer. Found a genuine, verified tenant in just 3 days."', name: 'Vikram S.', role: 'Property Owner, Delhi NCR', rating: 5, initials: 'VS', color: '#059669' },
        { text: '"The lifestyle filters are incredible. Only saw people with matching habits — no meat in my kitchen, early risers. Relocated stress-free!"', name: 'Aisha R.', role: 'Content Writer, Hyderabad', rating: 5, initials: 'AR', color: '#7C3AED' },
        { text: '"No broker, no commission. The direct chat inside the app made everything smooth. Saved ₹40,000 in brokerage!"', name: 'Rahul D.', role: 'Startup Founder, Pune', rating: 5, initials: 'RD', color: '#D97706' },
    ];

    return (
        <section style={{ padding: '100px 20px', background: '#F8FAFF' }}>
            <div style={{ maxWidth: '1100px', margin: '0 auto' }}>
                <div style={{ textAlign: 'center', marginBottom: '64px' }}>
                    <div style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', background: BLUE_PALE, color: BLUE, padding: '8px 20px', borderRadius: '30px', fontSize: '13px', fontWeight: '800', marginBottom: '16px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                        Real Stories
                    </div>
                    <h2 style={{ fontSize: 'clamp(28px, 4vw, 44px)', fontWeight: '800', color: '#111827', letterSpacing: '-1px', marginBottom: '16px' }}>
                        Trusted by thousands across India
                    </h2>
                    <p style={{ fontSize: '18px', color: '#6B7280', maxWidth: '480px', margin: '0 auto', lineHeight: '1.7' }}>
                        Real people. Real stories. Real savings.
                    </p>
                </div>

                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '20px' }}>
                    {reviews.map((r, i) => (
                        <div key={i} style={{ background: 'white', borderRadius: '24px', padding: '28px', boxShadow: '0 4px 20px rgba(0,0,0,0.05)', border: '1px solid #F3F4F6', display: 'flex', flexDirection: 'column', gap: '20px' }}>
                            {/* Stars */}
                            <div style={{ display: 'flex', gap: '4px', color: '#FBBF24' }}>
                                {Array.from({ length: r.rating }).map((_, si) => <IconStar key={si} />)}
                            </div>
                            <p style={{ fontSize: '15px', color: '#374151', lineHeight: '1.75', fontStyle: 'italic', margin: 0, flex: 1 }}>{r.text}</p>
                            {/* Author */}
                            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                <div style={{ width: '44px', height: '44px', borderRadius: '50%', background: r.color, color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: '800', fontSize: '14px', flexShrink: 0 }}>
                                    {r.initials}
                                </div>
                                <div>
                                    <div style={{ fontWeight: '800', color: '#111827', fontSize: '14px' }}>{r.name}</div>
                                    <div style={{ fontSize: '12px', color: '#9CA3AF', marginTop: '2px' }}>{r.role}</div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

// ============================================================
// === 6. DOWNLOAD CTA ===
// ============================================================
export const CTASection = () => (
    <section id="download" style={{ padding: '100px 20px' }}>
        <div style={{ maxWidth: '1100px', margin: '0 auto' }}>
            <div style={{ background: `linear-gradient(135deg, ${BLUE_DARK}, ${BLUE})`, borderRadius: '36px', padding: '72px 48px', textAlign: 'center', position: 'relative', overflow: 'hidden' }}>
                {/* Background orbs */}
                <div style={{ position: 'absolute', top: '-80px', right: '-80px', width: '320px', height: '320px', background: 'rgba(255,255,255,0.06)', borderRadius: '50%', pointerEvents: 'none' }} />
                <div style={{ position: 'absolute', bottom: '-60px', left: '-60px', width: '260px', height: '260px', background: 'rgba(255,255,255,0.04)', borderRadius: '50%', pointerEvents: 'none' }} />

                <div style={{ position: 'relative', zIndex: 1 }}>
                    <div style={{ width: '64px', height: '64px', background: BLUE_GLASS, backdropFilter: 'blur(10px)', border: '1px solid rgba(255,255,255,0.2)', borderRadius: '20px', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 24px', color: 'white' }}>
                        <IconPhone />
                    </div>
                    <h2 style={{ fontSize: 'clamp(28px, 5vw, 48px)', fontWeight: '800', color: 'white', letterSpacing: '-1.5px', marginBottom: '16px' }}>
                        Get the FlatLoop App
                    </h2>
                    <p style={{ fontSize: '18px', color: '#BFDBFE', marginBottom: '40px', maxWidth: '480px', margin: '0 auto 40px', lineHeight: '1.7' }}>
                        Download now and find your perfect flat, room, or PG — free to search, zero brokerage, no regrets.
                    </p>
                    <div style={{ display: 'flex', gap: '16px', justifyContent: 'center', flexWrap: 'wrap' }}>
                        <button type="button" onClick={() => window.open('https://play.google.com/store/apps/details?id=com.flatloop.app&hl=en_IN', '_blank')} style={{ background: 'white', color: BLUE_DARK, border: 'none', padding: '14px 32px', borderRadius: '14px', fontWeight: '800', fontSize: '15px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '10px', boxShadow: '0 4px 20px rgba(0,0,0,0.15)', transition: 'transform 0.2s' }}
                            onMouseOver={e => e.currentTarget.style.transform = 'translateY(-2px)'}
                            onMouseOut={e => e.currentTarget.style.transform = 'translateY(0)'}>
                            <IconPlayStore /> Android App
                        </button>
                        <button type="button" onClick={() => window.open('https://apps.apple.com/in/app/flatloop-flat-room-finder/id6766100303', '_blank')} style={{ background: BLUE_GLASS, backdropFilter: 'blur(10px)', color: 'white', border: '1px solid rgba(255,255,255,0.3)', padding: '14px 32px', borderRadius: '14px', fontWeight: '800', fontSize: '15px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '10px', transition: 'transform 0.2s' }}
                            onMouseOver={e => e.currentTarget.style.transform = 'translateY(-2px)'}
                            onMouseOut={e => e.currentTarget.style.transform = 'translateY(0)'}>
                            <IconAppStore /> iPhone App
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </section>
);

// ============================================================
// === 7. CONTACT / FAQ ===
// ============================================================
/**
 * The contact band at the foot of the home page.
 *
 * <p>This used to carry its own seven-question FAQ accordion alongside the
 * contact card. HomePage now owns the FAQ — deliberately, because its answers
 * are word-for-word the ones in the FAQPage structured data in
 * public/index.html, and structured data only earns a rich result when the
 * visitor can see the same answer on the page. Two different FAQs on one page
 * gave the crawler two different answers to the same question.
 *
 * <p>The removed copy also carried three claims the product does not support:
 * "10+ major Indian cities" (there are ten), profiles being "manually reviewed"
 * (only phone OTP is real), and reaching "thousands of verified tenants".
 */
export const ContactForm = () => (
    <section id="contact" style={{ padding: '0 20px 96px', background: '#F7F8FA' }}>
        <div style={{ maxWidth: '1180px', margin: '0 auto' }}>
            <div style={{ background: `linear-gradient(135deg, ${BLUE_DARK}, ${BLUE})`, borderRadius: '28px', padding: 'clamp(30px, 4vw, 44px)', color: 'white', position: 'relative', overflow: 'hidden', display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between', gap: '28px' }}>
                <div style={{ position: 'absolute', top: '-60px', right: '-40px', width: '220px', height: '220px', background: 'rgba(255,255,255,0.06)', borderRadius: '50%' }} />
                <div style={{ position: 'relative', zIndex: 1, flex: '1 1 380px' }}>
                    <h2 style={{ fontSize: 'clamp(22px, 3vw, 30px)', fontWeight: 800, margin: '0 0 10px', letterSpacing: '-0.8px' }}>Still have questions?</h2>
                    <p style={{ color: '#BFDBFE', fontSize: '15.5px', margin: 0, lineHeight: 1.65, maxWidth: '440px' }}>
                        Need help with a listing, a payment or your account? Email us and we will get back
                        to you — usually within a few hours on a weekday.
                    </p>
                </div>
                <a
                    href="mailto:contact@flatloop.in"
                    style={{ position: 'relative', zIndex: 1, background: 'white', color: BLUE_DARK, padding: '15px 28px', borderRadius: '14px', fontWeight: 800, textDecoration: 'none', fontSize: '15.5px', display: 'inline-flex', alignItems: 'center', gap: '10px', flexShrink: 0 }}
                >
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="4" width="20" height="16" rx="2" /><polyline points="2 6 12 13 22 6" /></svg>
                    contact@flatloop.in
                </a>
            </div>
        </div>
    </section>
);

// ============================================================
// === 8. RENT INSIGHTS / COMMUNITY DATA ===
// ============================================================
export const RentInsightsSection = ({ onViewInsights, onContribute }) => {
    const isMobile = useIsMobile(768);

    const cities = [
        { name: 'Delhi', emoji: '🏛️', avg: '₹12K–₹25K', lat: 28.6138, lng: 77.2090 },
        { name: 'Bangalore', emoji: '💻', avg: '₹10K–₹30K', lat: 12.9716, lng: 77.5946 },
        { name: 'Mumbai', emoji: '🌊', avg: '₹15K–₹40K', lat: 19.0760, lng: 72.8777 },
        { name: 'Hyderabad', emoji: '🏰', avg: '₹8K–₹20K', lat: 17.3850, lng: 78.4867 },
        { name: 'Pune', emoji: '🎓', avg: '₹8K–₹22K', lat: 18.5204, lng: 73.8567 },
        { name: 'Noida', emoji: '🏢', avg: '₹8K–₹18K', lat: 28.5355, lng: 77.3910 },
    ];

    const features = [
        { icon: 'insights', title: 'Community-Sourced Prices', desc: 'Real rent data shared by tenants — not brokers. See what people actually pay in your area.', color: BLUE, bg: BLUE_PALE },
        { icon: 'location', title: 'Interactive Price Map', desc: 'Map with price pills. Visualize rent hotspots across neighborhoods at a glance.', color: '#059669', bg: '#ECFDF5' },
        { icon: 'lock', title: 'Anonymous Contributions', desc: 'Share your rent anonymously. Help others make informed decisions — no personal data exposed.', color: '#7C3AED', bg: '#F5F3FF' },
    ];

    return (
        <section id="rent-insights" style={{ padding: '100px 20px', background: 'white' }}>
            <div style={{ maxWidth: '1100px', margin: '0 auto' }}>
                {/* Section header */}
                <div style={{ textAlign: 'center', marginBottom: '56px' }}>
                    <div style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', background: '#ECFDF5', color: '#059669', padding: '8px 20px', borderRadius: '30px', fontSize: '13px', fontWeight: '800', marginBottom: '16px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                        🆕 New Feature
                    </div>
                    <h2 style={{ fontSize: 'clamp(28px, 4vw, 44px)', fontWeight: '800', color: '#111827', letterSpacing: '-1px', marginBottom: '16px' }}>
                        Know the real rent<br /><span style={{ color: BLUE }}>before you move</span>
                    </h2>
                    <p style={{ fontSize: '18px', color: '#6B7280', maxWidth: '580px', margin: '0 auto', lineHeight: '1.7' }}>
                        Our community-driven rent insights show you actual prices tenants pay — not inflated broker quotes. Check average rent, min/max prices, and see data on a live map.
                    </p>
                </div>

                {/* Feature cards */}
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '20px', marginBottom: '48px' }}>
                    {features.map((f, i) => (
                        <div key={i} style={{
                            background: '#FAFAFA', borderRadius: '24px', padding: '28px',
                            border: '1px solid #F3F4F6', transition: 'all 0.2s',
                        }}
                            onMouseOver={e => { e.currentTarget.style.background = 'white'; e.currentTarget.style.boxShadow = '0 8px 32px rgba(0,0,0,0.08)'; }}
                            onMouseOut={e => { e.currentTarget.style.background = '#FAFAFA'; e.currentTarget.style.boxShadow = 'none'; }}>
                            <div style={{ width: '52px', height: '52px', background: f.bg, borderRadius: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '16px' }}>
                                <Icon3D name={f.icon} size={28} />
                            </div>
                            <h4 style={{ fontSize: '17px', fontWeight: '800', color: '#111827', marginBottom: '8px' }}>{f.title}</h4>
                            <p style={{ color: '#6B7280', fontSize: '14px', lineHeight: '1.7', margin: 0 }}>{f.desc}</p>
                        </div>
                    ))}
                </div>

                {/* City rent cards */}
                <div style={{ marginBottom: '40px' }}>
                    <h3 style={{ fontSize: '20px', fontWeight: '800', color: '#111827', textAlign: 'center', marginBottom: '24px' }}>
                        Average Rent Prices Across Cities
                    </h3>
                    <div style={isMobile ? {
                        display: 'flex', gap: '12px', overflowX: 'auto', paddingBottom: '12px',
                        scrollSnapType: 'x mandatory', WebkitOverflowScrolling: 'touch',
                        msOverflowStyle: 'none', scrollbarWidth: 'none',
                    } : {
                        display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '16px',
                    }}>
                        {cities.map((city, i) => (
                            <div key={i}
                                onClick={() => onViewInsights && onViewInsights({ name: city.name, lat: city.lat, lng: city.lng })}
                                style={{
                                    background: `linear-gradient(135deg, ${BLUE_PALE}, #DBEAFE)`,
                                    borderRadius: '20px', padding: '22px 20px', cursor: 'pointer',
                                    border: '1px solid #DBEAFE', transition: 'all 0.2s',
                                    scrollSnapAlign: 'start', minWidth: isMobile ? '180px' : 'auto',
                                    display: 'flex', alignItems: 'center', gap: '14px',
                                }}
                                onMouseOver={e => { e.currentTarget.style.transform = 'translateY(-3px)'; e.currentTarget.style.boxShadow = '0 8px 24px rgba(37,99,235,0.15)'; }}
                                onMouseOut={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = 'none'; }}>
                                <div style={{ fontSize: '28px' }}>{city.emoji}</div>
                                <div>
                                    <div style={{ fontWeight: '800', fontSize: '15px', color: '#111827' }}>{city.name}</div>
                                    <div style={{ fontSize: '13px', color: BLUE, fontWeight: '700' }}>{city.avg}/mo</div>
                                </div>
                                <div style={{ marginLeft: 'auto', color: BLUE, opacity: 0.5, fontSize: '18px' }}>→</div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* CTA buttons */}
                <div style={{ display: 'flex', gap: '16px', justifyContent: 'center', flexWrap: 'wrap', marginBottom: '48px' }}>
                    <button onClick={() => onViewInsights && onViewInsights({ name: 'Delhi', lat: 28.6138, lng: 77.2090 })}
                        style={{
                            background: `linear-gradient(135deg, ${BLUE_DARK}, ${BLUE_LIGHT})`,
                            color: 'white', border: 'none', padding: '16px 32px', borderRadius: '16px',
                            fontWeight: '800', fontSize: '15px', cursor: 'pointer',
                            boxShadow: '0 6px 24px rgba(37,99,235,0.35)', transition: 'all 0.2s',
                            display: 'flex', alignItems: 'center', gap: '10px',
                        }}
                        onMouseOver={e => e.currentTarget.style.transform = 'translateY(-2px)'}
                        onMouseOut={e => e.currentTarget.style.transform = 'translateY(0)'}>
                        📊 View Rent Insights
                    </button>
                    <button onClick={() => onContribute && onContribute()}
                        style={{
                            background: 'white', color: BLUE_DARK, border: `2px solid ${BLUE}`,
                            padding: '16px 32px', borderRadius: '16px', fontWeight: '800', fontSize: '15px',
                            cursor: 'pointer', transition: 'all 0.2s',
                            display: 'flex', alignItems: 'center', gap: '10px',
                        }}
                        onMouseOver={e => { e.currentTarget.style.background = BLUE_PALE; e.currentTarget.style.transform = 'translateY(-2px)'; }}
                        onMouseOut={e => { e.currentTarget.style.background = 'white'; e.currentTarget.style.transform = 'translateY(0)'; }}>
                        🤝 Contribute Your Rent
                    </button>
                </div>

                {/* SEO keywords — rent searches */}
                <div style={{ textAlign: 'center' }}>
                    <h3 style={{ fontSize: '16px', fontWeight: '800', color: '#374151', marginBottom: '16px' }}>Popular Rent Searches</h3>
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', justifyContent: 'center', maxWidth: '900px', margin: '0 auto' }}>
                        {[
                            'Average Rent in Delhi', 'Rent Prices Bangalore', 'PG Rent Mumbai',
                            'Flat Rent Hyderabad', '1BHK Rent Pune', 'Room Rent Noida',
                            'Rent Trends Gurgaon', 'Affordable Rent Chennai', 'Shared Flat Cost Delhi',
                            'Average PG Cost Bangalore', 'Rent per Month Mumbai',
                            'Room Rent Near Me', 'Cheapest Rent in Delhi',
                            'Rent Calculator India', 'Monthly Rent Comparison',
                        ].map((term, i) => (
                            <span key={i}
                                onClick={() => onViewInsights && onViewInsights({ name: term.split(' in ').pop() || term.split(' ').pop() })}
                                style={{
                                    background: '#F8FAFF', color: '#4B5563', padding: '6px 14px',
                                    borderRadius: '16px', fontSize: '12px', fontWeight: '600',
                                    border: '1px solid #E5E7EB', cursor: 'pointer', transition: 'all 0.2s',
                                }}
                                onMouseOver={e => { e.currentTarget.style.background = BLUE; e.currentTarget.style.color = 'white'; e.currentTarget.style.borderColor = BLUE; }}
                                onMouseOut={e => { e.currentTarget.style.background = '#F8FAFF'; e.currentTarget.style.color = '#4B5563'; e.currentTarget.style.borderColor = '#E5E7EB'; }}
                            >{term}</span>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};
